export const AssignmentsActions = {
  FETCH_ALL_ASSIGNMENTS_REQUEST: 'FETCH_ALL_ASSIGNMENTS_REQUEST',
  FETCH_ALL_ASSIGNMENTS_SUCCESS: 'FETCH_ALL_ASSIGNMENTS_SUCCESS',
  FETCH_ALL_ASSIGNMENTS_ERROR: 'FETCH_ALL_ASSIGNMENTS_ERROR',
}
